import {
	CreateInvestigationRequest,
	CreateInvestigationResponse,
	PasswordResetRequest,
	PasswordResetResponse,
	StatusUpdateRequest,
	StatusUpdateResponse,
	UpdateInvestigationRequest,
	InvestigationDetails,
} from '../@types';
import axiosInstance from './axios-instance';
import { Investigation, Page } from '../@types';
import { handleError } from './utils';

/**
 * Creates a investigation
 */
export const createInvestigation = (investigation: CreateInvestigationRequest) =>
	axiosInstance.post<any>('/investigation/createInvestigation/', investigation).catch(handleError);

/**
 * Gets a investigation by id
 */
export const getInvestigation = (investigationID: string) =>
	axiosInstance
		.get<InvestigationDetails>('/investigation/getinvestigation/id', {
			params: { id: investigationID },
		})
		.catch(handleError);

/**
 * Gets a page of investigations
 */
export const getInvestigations = () =>
	axiosInstance.get<InvestigationDetails[]>(`/investigation/getallinvestigations/`).catch(handleError);

/**
 * Updates a investigation's status
 */
export const updateInvestigation = (investigation: UpdateInvestigationRequest) =>
	axiosInstance
		.put<UpdateInvestigationRequest>('/investigation/updateInvestigation/', investigation)
		.catch(handleError);

/**
 * Deletes a investigation by id
 */
export const deleteInvestigation = (id: string) => {
	return axiosInstance
		.delete('/investigation/deleteInvestigationById', { data: { id: id } })
		.catch(handleError);
}
